import { useEffect } from 'react';

import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';

/**
 * Hook that registers a global keyboard shortcut (Escape) to close the player.
 * Only closes the player if no dropdown menus are currently open.
 *
 * @param onEscape - Callback function to execute when the shortcut is triggered
 */
export const useAudioEscapeShortcut = (onEscape: () => void): void => {
	const { hasOpenDropdownMenu } = useAudioPlayerStore();

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.code === 'Escape') {
				// If a dropdown menu is open, don't close the player
				// Let the dropdown handle the escape key itself
				if (hasOpenDropdownMenu) {
					return;
				}

				e.preventDefault();
				onEscape();
			}
		};

		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [onEscape, hasOpenDropdownMenu]);
};
